import React from "react";
import LogoutButton from "./LogoutButton";
import { withAuth0 } from "@auth0/auth0-react";

class AuthenticationButton extends React.Component {

  render() {
    const { isAuthenticated, isLoading, loginWithRedirect } = this.props.auth0;

    if (isLoading) return null;

    if (!isAuthenticated) {
      return (
        <button className="btn btn-primary" onClick={() => loginWithRedirect()}>
          Log In
        </button>
      );
    }

    return <LogoutButton />;
  }
}

export default withAuth0(AuthenticationButton);
